<script>
  import { eventState } from '../js/state.js';

  let organizerAlreadyTracking = false;

  $: if ($eventState && $eventState.google_analytics_id && $eventState.google_analytics_id != '') {
    addAnalytics($eventState.google_analytics_id);
  }

  function addAnalytics(gaid) {
    try {
      if (!organizerAlreadyTracking) {
        gtag('config', gaid, { page_title: $eventState.title });
        organizerAlreadyTracking = true;
      }
    } catch (err) {
      console.warn('Google Analytics not set up yet. Will try again shortly.');
      setTimeout(addAnalytics(gaid), 5000);
    }
  }

  function gaPulse() {
    setTimeout(function() {
      gtag('event', 'Pulse');
      gaPulse();
    }, 60000);
  }
  gaPulse();
</script>

<svelte:head>
  <script async src="https://www.googletagmanager.com/gtag/js?id=UA-165267677-1">

  </script>
  <script>
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', 'UA-165267677-1');
  </script>
</svelte:head>
